export class LinkRequestAcceptationFailedError extends Error {
    constructor() {
        super('An error occurred while trying to accept link request');
    }
}
